import { createUseStyles } from 'react-jss'
export default createUseStyles({
  replyMessage: {
    alignSelf: ({ message }) => message ? 'flex-end' : 'flex-start',
    fontSize: '16px',
    height: 'auto',
    maxWidth: '85%',
    padding: '.75em'
  }
})
